import { Box, Container, Stack, Typography, Grid } from '@mui/material';
// import clsx from 'clsx';
import { useState } from "react";
import { dataPlanes, imagenesModalPlans } from "../../data/data";
import tratamiento1 from "../../assets/Membership/Plans/plan1.png";
import tratamiento2 from "../../assets/Membership/Plans/plan2.png";
import imagenBackground from "../../assets/Membership/Plans/background.png";
import ModalImagenes from "../../components/ModalImagenes";
// import useScrollReveal from '../../hooks/useScrollReveal'; 

const BrandPlanes = () => {
// const [elementRef, isVisible] = useScrollReveal();
  const [openModal, setOpenModal] = useState(false);
  const [imagenesActuales, setImagenesActuales] = useState([]);

  const handleOpenModal = (imagenes) => {
    setImagenesActuales(imagenes);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setImagenesActuales([]);
  };

  return (
    // ref={elementRef} className= {clsx('fade-item', { 'is-visible': isVisible })}
    <Box sx={{
      backgroundPositionX: {xs: "-600px", sm:"0"},
      backgroundSize: "cover",
      pt: "24px",
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${imagenBackground})`,
      position: "relative",
      width: "100%",
      overflow: "visible"
    }}>

      <Container className="centeredContainer"
        sx={{
          justifyContent: "center",
          position: "relative",
          pb:"24px",
          gap:"24px",
        }}
      >
        <Box sx={{
          width: {xs: "100%", md:"60%"},
          textAlign: "center",
        }}>

          <Typography variant="h3" sx={{
            color: "rgb(255, 255, 255)",
            fontWeight: 900,
            lineHeight: 1.167,
            margin: 0,
            fontSize: {xs: "26px", sm:"36px", md:"38px"},
            textAlign: "center"
          }}>
            Nuestros planes
          </Typography>
        </Box>

        <Grid container
          sx={{
            display: "flex",
            flexFlow: "wrap",
            width: "80%",
          }}  
        >
          {dataPlanes.map((item, index) => (
            <Grid item xs={12} md={4} key={index} sx={{
              padding: "0 !important",
              paddingLeft: "0",
              paddingRigt: "0",
            }}>
              <Box
                sx={{
                  padding: {xs: "8px", lg:"24px"},
                }}  
              >
                <Stack sx={{
                  justifyContent: {xs:"unset", sm: "center"},
                  display:"flex",
                  flexDirection:"row",
                  textAlign:"center",
                  alignItems:"center",
                }}>
                  <Box sx={{
                    margin: "0",
                    display: "flex",
                    justifyContent: "center",
                  }}>
                    <Box
                      component="img"
                      src={item.icono}
                      alt="icono"
                      loading="lazy"
                      sx={{
                        borderRadius: "50%",
                        padding: "9.6px",
                        height: "80px",
                        width: "80px",
                      }}
                    />
                  </Box>

                  <Box sx={{
                    marginLeft: "8px"
                  }}>

                    <Typography variant="h4" textAlign="left" 
                    sx={{ 
                      fontSize: {xs: "20px", sm: "23px"}, 
                      margin:"0",
                      fontWeight: "900",
                      lineHeight: "1.235",
                      textAlign: "left",
                      alignItems: "center",
                      color: "rgb(255, 255, 255)",
                    }}>
                      {item.texto}
                    </Typography>

                    <Typography variant="h5" textAlign="left" 
                    sx={{ 
                      fontSize: {xs: "14px", sm: "16px"}, 
                      margin:"0",
                      fontWeight: "500",
                      lineHeight: "1.6",
                      textAlign: "left",
                      alignItems: "center",
                      color: "rgb(255, 255, 255)",
                    }}>
                      {item.subtexto}
                      <Typography variant="span" sx={{
                        margin: "0",
                        fontWeight: "400",
                        lineHeight: "1.5",
                        fontSize: "9px",
                      }}> 
                        {item.cantidad} 
                      </Typography>
                    </Typography>
                  </Box>
                </Stack>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Box sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: {xs: "column", sm:"row",},
        }}>

          <Box sx={{
            width: {xs: "70%", sm: "50%", md: "30%"},
            position: "relative",
            marginBottom: "8px",
          }}>
            <Box
              component="img"
              src={tratamiento1}
              alt="imagen Benefits"
              loading="lazy"
              sx={{
                objectFit: "fill",
                mb: "0",
                height: {xs: "100%"},
                width: {xs: "100%"},
              }}
            />
            <Box 
              component="button"
              className="static-button"
              onClick={() => handleOpenModal(imagenesModalPlans.basico)}
              sx={{
                borderWidth: "0px",
                borderStyle: "initial",
                borderColor: "initial",
                borderImage: "initial",
                textDecoration: "none",
                minWidth: "64px",
                padding: "6px 16px",
                borderRadius: '4px',
                backgroundColor: "rgb(255, 255, 255)",
                boxShadow: "rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px",
                position: "absolute",
                bottom: "15px",
                left: "50%",
                transform: "translateX(-55%)",
                outline: "0px",
              }}
            >
              <Typography variant="p"
              sx={{ 
                margin: "0px",
                fontSize: "12px",
                lineHeight: "1.5",
                color: "rgb(109, 219, 86)",
                fontWeight: "700",
              }}>
                BENEFICIOS
              </Typography>
            </Box>
          </Box>

          <Box sx={{
            width: {xs: "70%", sm: "50%", md:"30%"},
            position: "relative",
            marginBottom: "8px",
          }}>
            <Box
              component="img"
              src={tratamiento2}
              alt="imagen Benefits"
              loading="lazy"
              sx={{
                objectFit: "fill",
                mb: "0",
                height: {xs: "100%"},
                width: {xs: "100%"}
              }}
            />
            <Box 
              component="button"
              className="static-button"
              onClick={() => handleOpenModal(imagenesModalPlans.premium)}
              sx={{
                borderWidth: "0px",
                borderStyle: "initial",
                borderColor: "initial",
                borderImage: "initial",
                textDecoration: "none",
                minWidth: "64px",
                padding: "6px 16px",
                borderRadius: '4px',
                backgroundColor: "rgb(255, 255, 255)",
                boxShadow: "rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px",
                position: "absolute",
                bottom: "15px",
                left: "50%",
                transform: "translateX(-55%)",
                outline: "0px",
              }}
            >
              <Typography variant="p"
              sx={{ 
                margin: "0px",
                fontSize: "12px",
                lineHeight: "1.5",
                color: "rgb(109, 219, 86)",
                fontWeight: "700",
              }}>
                BENEFICIOS
              </Typography>
            </Box>
          </Box>

          <ModalImagenes
            open={openModal}
            handleClose={handleCloseModal}
            imagenes={imagenesActuales}
          />
        </Box>

        <Typography variant="h6" 
        sx={{
          color: "rgb(255, 255, 255)",
          textAlign: "center",
          fontWeight: 500,
          lineHeight: 1.2,
          margin: 0,
          width: {xs:"100%", md:"85%"},
          fontSize: {xs: "8px", md:"12px"},
          marginTop: {xs:"-16px", md:"-12px"},
        }}>
          (1) Los 4 beneficiarios incluyen al titular. (2) El costo por beneficiario extra es de $812 más IVA. Precios sujetos a cambio sin previo aviso. Precios de planes incluyen IVA.        
        </Typography>
      </Container>
    </Box>
  );
};

export default BrandPlanes;
